export default __webpack_public_path__ + "static/media/4.013ded80.png";